import './App.css';
import { useEffect, useState, useRef } from 'react'
import Form from "./interviewForm";
import Modal from 'react-modal';
import Logopikku from "./Pro2.jpg";
import AI from "./AI2.png";


function Hallinta() {

  const [language, setLanguage] = useState("en-US");
  const [isOpen, setIsOpen] = useState(true);
  const [login, setLogin] = useState(false);
  const [authentication, setAuthentication] = useState(false);
  const [form, setForms] = useState(false);
  const [flag, setFlags] = useState(false);
  const [haastattelu, setHaastattelu] = useState(false); 

  const addLogin = (value) => {
    setLogin(true);
};
  const addHaastattelu = (value) => {
    setHaastattelu(true);
  };


  const handleCloseModal = () => {
    setIsOpen(false);
  }


  function closeOpen() {
    setForms(false);
    setIsOpen(false);
  }

  
  useEffect(() => {

    const storedEmail = sessionStorage.getItem('email');
    if (storedEmail ) {
      setAuthentication(true);
      setFlags(true);
    } 
    
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    

    // Komponentin poistuessa, poista tapahtumankäsittelijä
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const myRef = useRef();

      useEffect(() => {
        myRef.current.focus();
  }, [flag]);

  
  return (
    <div className="Front" ref={myRef}>     
      {!login && <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={handleCloseModal}
        contentLabel="Esimerkki modaali"
        shouldCloseOnOverlayClick={false}
        className={form ? "ChoiceModal" : "AppModal"}
        overlayClassName="AppModalOverlay">
        
        {!authentication && <Form onAddLogin={addLogin} onAddHaastattelu={addHaastattelu} />} 
        
      </Modal>}
      
      {(isOpen && !login) && <div><img src={AI} className='AI' alt="The Interview Simulator"/></div>}
      {(isOpen && !login) && <div><img src={Logopikku} className='LomakeLogo' alt="Lassi Albin"></img></div>}
      {(isOpen && !login) && <div><h1 className='LomakeTitle'>The Interview Simulator</h1></div>} 
    
      {(isOpen && !login) && <div><h1 className='Footer'>© 2025 TCG. ALL RIGHTS RESERVED.</h1></div>}   
   
        
      
    </div>
  );}
  
export default Hallinta;